import type { Dimensions } from "../types/Dimensions";

export default (
  dimensions: Dimensions,
  maxWidth: number
): Dimensions => {
  const invertedAspectRatio = dimensions.heigth / dimensions.width;
  let maxImageWidth = dimensions.width;
  let maxImageHeight = dimensions.heigth;

  /*
   * If image is wider than body width, resize it
   * we get double of body width because of retina screens.
   */
  if (dimensions.width > maxWidth * 2) {
    maxImageWidth = maxWidth * 2;
    maxImageHeight = Math.round(maxImageWidth * invertedAspectRatio);
  }

  return {
    heigth: maxImageHeight,
    width: maxImageWidth,
  };
}
